module.exports = require("accounting");


//////////////////
// WEBPACK FOOTER
// external "accounting"
// module id = 23
// module chunks = 0